import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ChatCircleText, Storefront } from "@phosphor-icons/react";
import { PageHeader } from "@/components/layout/AppShell";
import { AgentAvatar } from "@/components/agent/AgentCard";
import { api, fmtDate } from "@/lib/api";
import { LibraryProducts } from "@/components/agent/LibraryProducts";

export default function Library() {
  const { data = [], isLoading } = useQuery({ queryKey: ["library"], queryFn: async () => (await api.get("/library")).data });
  return (
    <div>
      <PageHeader eyebrow="Adquiridos" title="Biblioteca" subtitle="Tus agentes, modelos locales y programas, con sus descargas y licencias." actions={<Link to="/marketplace" className="btn-ghost" data-testid="library-marketplace-button"><Storefront size={18} /> Explorar</Link>} />
      <div className="px-6 py-10 lg:px-12">
        {isLoading ? <div className="h-px bg-white/10 thinking-beam" /> : data.length === 0 ? (
          <div className="border border-dashed border-white/15 p-16" data-testid="library-empty">
            <p className="font-display text-3xl font-bold">Aún no tienes agentes.</p>
            <p className="mt-2 text-zinc-500">Descubre agentes listos para trabajar en el marketplace.</p>
            <Link to="/marketplace" className="btn-primary mt-6" data-testid="library-empty-explore">Ir al marketplace</Link>
          </div>
        ) : (
          <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 xl:grid-cols-3">
            {data.map(({ agent: a, purchase: p }) => (
              <div key={a.agent_id} className="flex flex-col justify-between bg-[#080808] p-6" data-testid={`library-item-${a.agent_id}`}>
                <div className="flex items-start gap-4">
                  <AgentAvatar icon={a.icon} color={a.color} size={48} />
                  <div className="min-w-0"><p className="font-display text-lg font-bold">{a.name}</p><p className="mt-1 line-clamp-2 text-sm text-zinc-500">{a.tagline}</p></div>
                </div>
                <div className="mt-6 flex items-center justify-between border-t border-white/5 pt-4">
                  <span className="text-xs text-zinc-500">{p.pricing_type === "monthly" ? "Suscripción" : p.pricing_type === "free" ? "Gratis" : "Compra"} · {fmtDate(p.created_at)}</span>
                  <Link to={`/chat/${a.agent_id}`} className="btn-primary !px-4 !py-2" data-testid={`library-chat-${a.agent_id}`}><ChatCircleText size={16} /> Usar</Link>
                </div>
              </div>
            ))}
          </div>
        )}
        <h2 className="mb-5 mt-14 font-display text-2xl font-bold tracking-tight" data-testid="library-products-heading">Modelos locales y software</h2>
        <LibraryProducts />
      </div>
    </div>
  );
}
